import Cookies from 'js-cookie';

export const setCookie = (name: string, value: string) => {
  Cookies.set(name, value, {
    expires: 1,
    secure: false,
    sameSite: 'lax',
    path: '/'
  });
};

export const getCookie = (name: string) => {
  return Cookies.get(name);
};

export const removeCookie = (name: string) => {
  Cookies.remove(name, {
    path: '/',
    domain: window.location.hostname === 'localhost' ? 'localhost' : window.location.hostname
  });
};
